import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { PaymentDetailModal } from '../../../modals';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FinanceService } from '../../../services';
import { Location } from '@angular/common';
import { InvoiceAdvancedSearchService } from '../invoice-advanced-search.service';
import { headers2 } from '../headers';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-invoice-payment-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss'],
})
export class InvoicePaymentListComponent implements OnInit, OnDestroy {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  success: any;
  error: any;
  invoices: Array<any> = [];
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  departments: Array<any> = [];
  paymentSearchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'invoiceNumber',
        op: 'cn',
        data: '',
      },
      {
        field: 'gatewayTransactionRefId',
        op: 'cn',
        data: '',
      },
    ],
  };
  nonPaymentSearchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'gatewayTransactionRefId',
        op: 'cn',
        data: '',
      },
    ],
  };
  searchFilter = this.paymentSearchFilter;
  customerNCCID: string;
  organizationId: string;
  advancedSearchSubscription!: Subscription;
  exportSearchSubscription!: Subscription;
  advancedSearchVisible = false;
  headers = headers2;
  isInvoiced = false;
  baseUrl = environment.API_SERVER;
  financeBaseUrl = environment.FINANCE_API_SERVER;
  exportFilter: AppFilter;
  exportSearchFilter: any;
  constructor(
    private modalService: SuiModalService,
    private financeSvc: FinanceService,
    private location: Location,
    private invoiceAdvancedSearch: InvoiceAdvancedSearchService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated' });
    let url: any = this.location.path();
    console.log(url.split('/').pop());
    if (url.split('/').pop() != 'payment') {
      this.searchFilter = this.nonPaymentSearchFilter;
      this.isInvoiced = false;
    } else {
      this.searchFilter = this.paymentSearchFilter;
      this.isInvoiced = true;
    }

    // this.customerNCCID = '000-0112';
    this.customerNCCID = JSON.parse(
      window.localStorage.getItem('organization')
    )['jpaContractor']['nccId'];
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.exportFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      // sidx: "actionDate",
      rows: 1000,
      sord: 'desc',
    });
    this.getPage(1);
    // this.payment(1);s
  }

  goBack() {}

  view(payment) {
    this.modalService
      .open(new PaymentDetailModal('Payment Detail', payment, ModalSize.Tiny))
      .onApprove((value: any) => {})
      .onDeny(() => {});
  }
  download(payload) {
    const filename = 'receipt.pdf';
    const url = `${this.financeBaseUrl}/public/media/?media=${payload}&file_name=${filename}`;
    window.open(url, '_blank');
  }
  // get page request organization with filter params
  getPage(page: number) {
    // set the page number from the caller
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.financeSvc
      .getPayments({
        params: {
          ...this.filter,
          ...{ customerNccId: this.customerNCCID },
          _nullInvoiceNumber: !this.isInvoiced,
        },
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
          this.invoices = res['rows'];
          this.exportFilter.rows = this.totalItems;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  searchRecords(search) {
    let searchFilter = this.searchFilter;
    // searchFilter.rules[0].data = search;
    searchFilter.rules.forEach((rule) => {
      rule.data = search;
    });
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }
  onDisplayRecords(value) {
    this.filter.rows = value;
    this.getPage(this.filter.page);
  }

  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }

  advancedSearch(event: any) {
    this.exportSearchFilter = event;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.getPage(1);
  }

  downloadInvoice(media: any) {
    const filename = 'invoice.xlsx';
    const url = `${this.baseUrl}/public/media/?media=${media}&file_name=${filename}`;
    window.open(url, '_blank');
  }

  exportAdv() {
    this.pending = true;
    if (this.exportSearchFilter) {
      this.exportFilter.filters = JSON.stringify(this.exportSearchFilter);
    }
    this.invoiceAdvancedSearch
      .paymentExport({
        invoiced: this.isInvoiced,
        params: {
          ...this.exportFilter,
          customerNccId: this.customerNCCID,
          _nullInvoiceNumber: !this.isInvoiced,
        },
      })
      .subscribe(
        (res) => {
          this.downloadInvoice(res['file']);
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  ngOnInit(): void {
    this.advancedSearchSubscription =
      this.invoiceAdvancedSearch.toggleSearch.subscribe((route: string) => {
        if (route != this.invoiceAdvancedSearch.routes.list) {
          this.advancedSearchVisible = !this.advancedSearchVisible;
        }
      });

    this.exportSearchSubscription =
      this.invoiceAdvancedSearch.exportSearch.subscribe((route: string) => {
        if (route != this.invoiceAdvancedSearch.routes.list) {
          this.exportAdv();
        }
      });
  }

  ngOnDestroy(): void {
    this.advancedSearchSubscription.unsubscribe();
    this.exportSearchSubscription.unsubscribe();
  }
}
